<h4 class="group-name">
    <span>
        <span class="fa fa-arrows" [ngClass]="{ disabled: !policyPermissions.editField }"></span>
        <span>{{ group.name }}</span> <span class="group-size">({{ group.fields.length }} Fields)</span>
    </span>
    <span class="group-name__controls">
        <button type="button" class="cm-link" *ngIf="policyPermissions.addField" (click)="addFieldToGroup.emit(group)">
            + Add field to group
        </button>
        <button type="button" class="cm-link" (click)="toggleFields()">{{ showFields ? 'Collapse' : 'Expand' }}</button>
        <button type="button" class="cm-link" *ngIf="policyPermissions.editGroup" (click)="edit.emit(group)">
            Edit
        </button>
        <button type="button" class="cm-link" *ngIf="policyPermissions.deleteFieldGroup" (click)="onRemove(group)">
            Delete group and fields
        </button>
    </span>
</h4>
<div class="fields" *ngIf="showFields"><ng-content></ng-content></div>
